import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { initPlugin } from './providers';

const PluginArea = memo(styled.div`
  min-height: 100%;
  position: relative;
  iframe {
    position: absolute;
  }
`);

export default class InteractivePlugin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.pluginRef = null;

    this.resolveSubscriptions = null;
    this.subscriptions = new Promise((resolve) => {
      this.resolveSubscriptions = resolve;
    });

    this.setPluginRef = this.setPluginRef.bind(this);
    this.setComponentId = this.setComponentId.bind(this);

    this.state = { componentId: null };
  }

  setPluginRef(el) {
    this.pluginRef = el;
    const { context, componentId, studentScope, componentConfigs, parentConfig, studentId } = this.props;

    initPlugin({
      el,
      context,
      componentId,
      studentScope,
      componentConfigs,
      parentConfig,
      studentId,
    }).then(({ subscriptions }) => {
      this.resolveSubscriptions(subscriptions);
    });
  }

  async setComponentId(componentId) {
    const subscriptions = await this.subscriptions;
    subscriptions.notify({ id: this.subscriptions.rootInstance,
      resourceName: 'SELECTION_RESOURCE',
      methodName: 'SUBSCRIBE',
      payload: {
        selection: [{
          type: 'REVIEW_FOCUS_SELECTION',
          path: ['**', componentId],
        }],
      },
    });
  }

  render() {
    return <PluginArea ref={this.setPluginRef} />;
  }
}

InteractivePlugin.propTypes = {
  context: PropTypes.string,
  componentId: PropTypes.string,
  studentScope: PropTypes.object,
  componentConfigs: PropTypes.object,
  parentConfig: PropTypes.object,
  studentId: PropTypes.string,
};
